import { useEffect, useState } from "react";
import { useHistory } from "react-router";

export default function useSearchParams() {
  const [searchParams, setSearchParams] = useState(new URLSearchParams(window.location.search));
  const [queryString, setQueryString] = useState(searchParams.toString());
  const history = useHistory();

  useEffect(() => {
    const unListen = history.listen((location) => {
      const _searchParams = new URLSearchParams(location.search);
      setSearchParams(_searchParams);
      setQueryString(_searchParams.toString());
    });
    return () => unListen();
  }, []);

  function append(name, value) {
    searchParams.append(name, value);
    history.push(`?${searchParams.toString()}`);
    setQueryString(searchParams.toString());
  }

  const entries = () => Array.from(searchParams.entries());

  const get = (name) => searchParams.get(name);

  const getAll = (name) => searchParams.getAll(name);

  const has = (name) => searchParams.has(name);

  const keys = () => Array.from(searchParams.keys());

  const remove = (name) => {
    searchParams.delete(name);
    history.push(`?${searchParams.toString()}`);
    setQueryString(searchParams.toString());
  };

  const removeAll = (extraData) => {
    const _searchParams = new URLSearchParams();
    if (extraData) {
      Object.keys(extraData).forEach((key) => {
        _searchParams.set(key, extraData[key]);
      });
    }
    setSearchParams(_searchParams);
    history.push(`?${_searchParams.toString()}`);
    setQueryString(_searchParams.toString());
  };

  function set(name, value) {
    searchParams.set(name, value);
    history.push(`?${searchParams.toString()}`);
    setQueryString(searchParams.toString());
  }

  function setAndRemove(setData, removeList) {
    if (setData) {
      Object.keys(setData).forEach((key) => {
        searchParams.set(key, setData[key]);
      });
    }
    if (removeList) {
      removeList.forEach((key) => {
        searchParams.delete(key);
      });
    }
    setSearchParams(searchParams);
    history.push(`?${searchParams.toString()}`);
    setQueryString(searchParams.toString());
  }

  function sort() {
    searchParams.sort();
    setQueryString(searchParams.toString());
  }

  const values = () => Array.from(searchParams.values());

  return [queryString, { append, entries, get, getAll, has, keys, remove, removeAll, set, sort, values, setAndRemove }];
}
